<script lang="ts">
  import { onMount } from 'svelte';
  import { getAppContext } from '../../app/context.js';
  import { applyUserPreferencesToDocument } from './apply-preferences.js';

  const { repositories, platform } = getAppContext();

  onMount(() => {
    void repositories.preferences.load().then((preferences) => {
      applyUserPreferencesToDocument(preferences);
      platform.audio.setEnabled(preferences.soundEnabled);
    });
  });
</script>
